export default __webpack_public_path__ + "static/media/11.dbd718ef.jpg";